export enum SpecificationCategory {
  engine = 'motor_section',
  transmission = 'transmission_section',
  weightsAndCapacities = 'weights_capacities_section',
  chassis = 'chassis_section',
  brakingSystem = 'braking_system_section',
  equipment = 'equipment_section',
  electricSystem = 'electric_system_section',
  dimensions = 'dimensions_section',
}
